import styled from "styled-components";

export const Container = styled.div`
  @media only screen and (min-width: 1000px) { /* FOR DESTOPS */
    display: flex;
    justify-content: space-around;
    height: 60vh;
    margin-top: 100px;
    margin-bottom: 150px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  }

  @media only screen and (min-width: 250px) and (max-width: 1000px){
    display: flex;
    flex-direction: column;
    height: 60vh;
    margin-top: 100px;
    margin-bottom: 1000px;
    padding: 20px;
    gap: 40px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  }
`;

export const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ul {
    margin-left: 30px;
  }
`;
export const Title = styled.h1`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 2em;
  color: #1485c7;
  max-width: 500px;
`;
export const Paragraph = styled.p`
  text-align: center;
  max-width: 600px;
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;

  span {
    color: #1484c7;
  }
`;
export const Heading = styled.p`
  font-weight: bold;
  margin-bottom: -20px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media only screen and(max-width: 1000px){
    ul{
    margin-left: 10px;
    max-width: 600px;
  }
 }


 @media only screen and (min-width: 250px) and (max-width: 1000px){
    ul{
    margin-top: 10px;
    margin-left: 10px;
    max-width: 300px;
  }
 }
`;
export const Image = styled.div``;
